if (!customElements.get('complete-the-set')) {
  class CompleteTheSet extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      try {
        this.tiers = JSON.parse(this.dataset.tiers || '[]');
      } catch (e) {
        this.tiers = [];
      }

      this.track = this.querySelector('.cts__fill');
      this.dots = Array.from(this.querySelectorAll('.cts__dot'));
      this.hint = this.querySelector('.cts__hint');

      this.bindRows();
      this.bindAddAll();
      this.renderProgress(parseInt(this.dataset.count, 10) || 0);
      this.refreshCount();
    }

    bindRows() {
      this.querySelectorAll('.cts__item').forEach((item) => {
        const select = item.querySelector('[data-cts-select]');
        const price = item.querySelector('[data-cts-price]');
        const button = item.querySelector('[data-cts-add]');

        if (select && price) {
          select.addEventListener('change', () => {
            const opt = select.options[select.selectedIndex];
            if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
          });
        }

        if (button) {
          button.addEventListener('click', () => {
            const id = select ? select.value : button.dataset.variantId;
            if (!id) return;
            this.addItems([{ id: Number(id), quantity: 1 }], button);
          });
        }
      });
    }

    bindAddAll() {
      const button = this.querySelector('[data-cts-addall]');
      if (!button) return;
      button.addEventListener('click', () => {
        const items = [];
        this.querySelectorAll('.cts__item').forEach((item) => {
          const select = item.querySelector('[data-cts-select]');
          if (select && select.value) items.push({ id: Number(select.value), quantity: 1 });
        });
        if (items.length) this.addItems(items, button);
      });
    }

    addItems(items, button) {
      if (button) button.setAttribute('disabled', 'disabled');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-bubble', 'main-cart'] })
      })
        .then((r) => r.json())
        .then((data) => {
          if (data && data.status && data.status !== 200) {
            console.error('complete-the-set:', data.description || data.message);
            return;
          }
          if (data && data.sections) this.updateSections(data.sections);
          this.refreshCount();
        })
        .catch((e) => console.error('complete-the-set:', e))
        .finally(() => {
          if (button) button.removeAttribute('disabled');
        });
    }

    updateSections(sections) {
      const targets = [
        { id: 'Cart-Drawer', key: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', key: 'cart-bubble', selector: '.sto-pns-secondary-area--item-count' },
        { id: 'cart-drawer-toggle', key: 'cart-bubble', selector: '.sto-pns-secondary-area--item-amount' },
        { id: 'Cart', key: 'main-cart', selector: '.sto-pns-cart-form' }
      ];

      targets.forEach((t) => {
        const host = document.getElementById(t.id);
        const html = sections[t.key];
        if (!host || !html) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html').querySelector(t.selector);
        const target = host.querySelector(t.selector) || host;
        if (parsed && target) target.innerHTML = parsed.innerHTML;
      });

      const drawer = document.getElementById('Cart-Drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
      }
    }

    refreshCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => this.renderProgress(cart.item_count || 0))
        .catch(() => {});
    }

    renderProgress(count) {
      const tiers = this.tiers;
      if (!tiers.length) return;

      const total = tiers.length;
      const posOf = (i) => ((i + 1) / total) * 100;

      let fill;
      if (count >= tiers[total - 1].qty) {
        fill = 100;
      } else {
        let idx = tiers.findIndex((t) => count < t.qty);
        if (idx < 0) idx = total - 1;
        const prevQty = idx === 0 ? 0 : tiers[idx - 1].qty;
        const prevPos = idx === 0 ? 0 : posOf(idx - 1);
        const span = posOf(idx) - prevPos;
        const denom = tiers[idx].qty - prevQty;
        const frac = denom > 0 ? (count - prevQty) / denom : 0;
        fill = prevPos + span * Math.max(0, Math.min(1, frac));
      }

      if (this.track) this.track.style.width = fill.toFixed(2) + '%';

      this.dots.forEach((dot) => {
        const qty = parseInt(dot.dataset.qty, 10) || 0;
        dot.classList.toggle('is-on', count >= qty);
      });

      if (this.hint) {
        if (count >= tiers[total - 1].qty) {
          this.hint.textContent = "You've unlocked " + tiers[total - 1].pct + '% off.';
        } else {
          let idx = tiers.findIndex((t) => count < t.qty);
          if (idx < 0) idx = total - 1;
          const need = tiers[idx].qty - count;
          this.hint.textContent =
            'Add ' + need + (need > 1 ? ' items' : ' item') + ' to unlock ' + tiers[idx].pct + '% off.';
        }
      }
    }
  }

  customElements.define('complete-the-set', CompleteTheSet);
}
